export class PromotionProgramType {
    name = null;
    code = null;
    fromDate = null;
    toDate = null;

}